<template>
  <ElForm
    ref="developer"
    :initial-value="developer"
    :model="developerModel"
    :rules="rules"
    label-position="top"
    @submit.native.prevent="submitUpdatedDeveloperDetail"
  >
    <ElFormItem :label="$t('DEVELOPER_TITLES.FA_TITLE')" prop="nameFa">
      <ElInput
        v-model="developerModel.nameFa"
        type="text"
        name="nameFa"
        required
      />
    </ElFormItem>

    <ElFormItem :label="$t('DEVELOPER_TITLES.FA_WEBSITE')" prop="websiteFa">
      <ElInput
        v-model="developerModel.websiteFa"
        dir="ltr"
        type="text"
        name="websiteFa"
        class="text-latin"
      />
    </ElFormItem>

    <ElFormItem :label="$t('DEVELOPER_TITLES.EN_TITLE')" prop="nameEn">
      <ElInput
        v-model="developerModel.nameEn"
        type="text"
        name="nameEn"
        class="text-latin"
        required
      />
      <p class="el-form-item__help">
        {{ $t('DEVELOPER_TITLES.NAME_INPUT_DESC') }}
      </p>
    </ElFormItem>

    <ElFormItem :label="$t('DEVELOPER_TITLES.EN_WEBSITE')" prop="websiteEn">
      <ElInput
        v-model="developerModel.websiteEn"
        dir="ltr"
        type="text"
        name="websiteEn"
        class="text-latin"
      />
    </ElFormItem>

    <ErrorsList
      v-if="updateDetailFormErrors"
      :errors="updateDetailFormErrors"
    />

    <ElButton
      type="primary"
      :loading="updateDetailProcessing"
      @click.native="submitUpdatedDeveloperDetail"
    >
      {{ $t('SAVE') }}
    </ElButton>

    <ElButton type="text" :plain="true" @click.native="$modal.close()">
      {{ $t('CANCEL') }}
    </ElButton>

    <!-- dirty hack until ElementUI ends up with a solution -->
    <input v-show="false" type="submit" />
  </ElForm>
</template>

<script>
import form from '@/mixins/form';
import { DeveloperTitles } from '@/api/api';
import packageName from '@/mixins/packageName';
import ErrorsList from '@@/common/ErrorsList';
import required from '@/utils/validation-rules/required';
import urlValidation from '@/utils/validation-rules/url';

export default {
  name: 'EditDeveloperDetailsModal',

  components: { ErrorsList },
  mixins: [form, packageName],

  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    developer: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      developerModel: {
        ...this.developer,
      },
      updateDetailProcessing: false,
      updateDetailFormErrors: null,
    };
  },
  computed: {
    rules() {
      return {
        nameFa: required(),
        websiteFa: urlValidation(),
        nameEn: required(),
        websiteEn: urlValidation(),
      };
    },
  },
  watch: {
    isOpen: {
      immediate: true,
      handler(open) {
        if (open) this.setInitialData();
        else this.reset();
      },
    },
  },
  methods: {
    setInitialData() {
      this.developerModel = {
        ...this.developer,
      };
    },
    submitUpdatedDeveloperDetail() {
      if (!this.isValid('developer')) {
        return false;
      }
      return this.updateDeveloperDetail();
    },
    updateDeveloperDetail() {
      this.updateDetailProcessing = true;
      const { id, ...developer } = this.developerModel;

      return DeveloperTitles.updateDetail({ id }, { ...developer })
        .then(({ body: { message } }) => {
          this.$message.success(message);
          this.updateDetailFormErrors = null;
          this.$modal.close(true);
        })
        .catch(({ body: { message, errors } = {} }) => {
          if (message) {
            this.$message.error(message);
          }
          if (errors) {
            this.updateDetailFormErrors = [...errors];
          }
        })
        .finally(() => {
          this.updateDetailProcessing = false;
        });
    },
    reset() {
      this.resetForm('developer');
    },
  },
};
</script>
